export default __webpack_public_path__ + "images/4f88c2ef0a140146dbf6fc5bd2acfbe8.png";